var updateTimer;
function getTotalPrice(cart, output = "discounted"){
  var cart 					= JSON.parse(cart);
  //console.log("cart",cart);
  var totalPrice			= 0;
  var discount_cookie 		= getCookie("discount_code");
  if(discount_cookie !== "undefined" && discount_cookie != ""){
    var checkCode 		= checkDiscountCode(discount_cookie);      	
    if(checkCode != false){
      var cartItems			= cart.items;  
      for(i = 0; i < cartItems.length; i++){
        var item = cartItems[i];
        var tags = $(".dgs-cartbar-cart-items").find(".dgs-cartbar-item[data-cart-item-key='"+item.key+"']").attr("product-tags");
        tags = (tags) ? tags : [];
        //console.log("tags",tags);
        if(!tags.includes("nodiscount") || output == "all"){
          if(item.properties !== null){
            if(!item.properties.hasOwnProperty('_bundle')){
              if(!item.properties.hasOwnProperty('_gift')){
                var $lineProductID 		= (item.product_id).toString();
                var $lineQuantity 		= parseInt(item.quantity);
                var $linePrice 			= parseInt(item.final_price);
                var $priceDiscounted	= discountedPrice($lineProductID,"",$linePrice);
                var discountPrice		= $priceDiscounted * $lineQuantity;
                totalPrice 				= totalPrice + parseInt(discountPrice);
              }
            }
          }
        }else{ totalPrice 				= totalPrice + parseInt(item.final_line_price); }
        //console.log("totalPrice",totalPrice);
      }
    }else{ totalPrice = cart.total_price; }
  }else{ totalPrice = cart.total_price; }
  return totalPrice;
}

function updateCart(form_id,type,wait = 650){
  if(updateTimer){clearTimeout(updateTimer);}
  updateTimer	= setTimeout(function(){
    if(type == "page"){
      var $button			= $(".dgs-cart-footer-button");
      $button.attr('loadercover','').prop("disabled", true);
    }else if(type == "sidebar"){
      $(".dgs-cartbar-button").prop("disabled", true);
      //$(".dgs-cartbar-cart").attr("loadercover","");
      $(".dgs-cartbar-item[update]").find(".dgs-cartbar-item-response:not([data-response='delete'])").attr("data-response","loading").fadeIn();
    }
    let updateCartForm = document.querySelector('#'+form_id);
    let formData = new FormData(updateCartForm);
    fetch('/cart/update.js',{ method:'POST',dataType:'json',contentType:'application/json',body:formData })
    .then(response => response.json())
    .then(data => { updateCartOk(type,JSON.stringify(data)); })
    .catch((error) => { failCart('update',type); });
  }, wait);
}

function updateCartContent(type){
  var modal = parseInt($(".dgs-modal").attr("data-open")); 
  var open = parseInt($("body").attr("data-cartbar"));
  if(modal == 1){ var open = 1; }
  //closeModal();
  if(type == "page"){
    loadContent('dgs-cart-page','shopify-section-dgs-cart-page',0,open);
  }else if(type == "sidebar"){
    loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar',0,open);
  }
}

function checkCart(origin,type,cartJSON,toastArr,reload = 1){
  var dgsSessionObj 	= dgsSession();
  var dgsSessionConfig	= dgsSession(dgsSessionObj,'read','config');
  var dgsSessionGift	= dgsSession(dgsSessionObj,'read','gift');
  var cartJSON 			= JSON.parse(cartJSON);
  var cartBundles 		= false;
  var cartGift 			= false;
  var cartGiftShow		= dgsSessionGift['_show'];
  var cartGiftExist		= parseInt(gift_exist);
  var cartPfand 		= false;
  var cartPfandItem		= false;
  var cartPfandItems	= false;
  var cartPfandCount	= 0;
  console.log(cartJSON);
  for(i = 0; i < cartJSON.items.length; i++){
    var item = cartJSON.items[i];
    if(item.properties !== null){
      if((item.properties).hasOwnProperty('_master')){ cartBundles = true; }
      if((item.properties).hasOwnProperty('_gift')){
        cartGift = item.key;
        if(item.variant_id){}
      }
      if((item.properties).hasOwnProperty('_pfand')){ 
        cartPfand 		= true;
        cartPfandCount 	= cartPfandCount + (parseInt(item.properties['_pfand']) * parseInt(item.quantity));
      }
    }
    if(item.handle == "pfand"){ 
      cartPfandItem 	= item.id;
      cartPfandItems	= item.quantity;
    }
  }
  if(cartGiftShow){
    var cartGiftAvailable	= ('_available' in dgsSessionGift) ? encodeLiquidData(dgsSessionGift['_available']) : false;
    var cartGiftVariant		= ('_variant' in dgsSessionGift) ? parseInt(dgsSessionGift['_variant']) : false;
    var cartGiftPfand		= ('_pfand' in dgsSessionGift) ? parseInt(dgsSessionGift['_pfand']) : false;
    var cartGiftQuantity	= ('_quantity' in dgsSessionGift) ? encodeLiquidData(dgsSessionGift['_quantity']) : false;
    var cartGiftAuto		= (dgsSessionGift['_auto'] && cartGiftAvailable == 1) ? true : false;
  }
  var mcgp = encodeLiquidData(dgsSessionConfig['_mcgp']) * 1;
  var total_price = getTotalPrice(JSON.stringify(cartJSON)); 
  //console.log(origin,cartGift,mcgp,total_price);
  if(cartGift && (cartGiftExist == 0 || cartGiftAvailable == 0 || !cartGiftShow)){
    var deleteGift = "updates["+cartGift+"]=0";
    $.post('/cart/update.json',deleteGift, "json").done(function(){
      sessionStorage.setItem("currentEventbox",""); 
      if(origin == "add"){ addCartContent(type,toastArr); }else{ updateCartContent(type); }
    }).fail(function(){ failCart(origin,type); });
  }else if(cartGift && total_price < mcgp){
    var deleteGift = "updates["+cartGift+"]=0";
    $.post('/cart/update.json',deleteGift, "json").done(function(){
      sessionStorage.setItem("currentEventbox","gift"); 
      if(origin == "add"){ addCartContent(type,toastArr); }else{ updateCartContent(type); }
    }).fail(function(){ failCart(origin,type); });
  }else if(!cartGift && cartGiftAuto && total_price >= mcgp){    
    if(cartGiftPfand >= 1){ var items = [{quantity:cartGiftQuantity,id:cartGiftVariant,properties:{'_gift':cartGiftVariant,'_pfand':cartGiftPfand}}]; }
    else{ var items = [{quantity:cartGiftQuantity,id:cartGiftVariant,properties:{'_gift':cartGiftVariant}}]; }
    $.post('/cart/add.json', {items:items}, "json").done(function(){
      sessionStorage.setItem("currentEventbox","");
      if(origin == "add"){ addCartContent(type,toastArr); }else{ updateCartContent(type); }
    }).fail(function(){ failCart(origin,type); });
  }else if(cartPfand && !cartPfandItem){
    $.post('/cart/add.json', {items:[{quantity:cartPfandCount,id:pfandID}]}, "json").done(function(){
      if(origin == "add"){ addCartContent(type,toastArr); }else{ updateCartContent(type); }
    }).fail(function(){ failCart(origin,type); });
  }else if(cartPfandItem && cartPfandItems != cartPfandCount){
    var updatePfand = "updates["+cartPfandItem+"]="+cartPfandCount;
    $.post('/cart/update.json', updatePfand, "json").done(function(){ 
      if(origin == "add"){ addCartContent(type,toastArr); }else{ updateCartContent(type); }
    }).fail(function(){ failCart(origin,type); });
  }else if(reload == 1){ 
    if(origin == "add"){ addCartContent(type,toastArr); }else{ updateCartContent(type); }
  }else{ $(".dgs-cartbar-button").removeAttr('loadercover').prop("disabled", false); }
}
function updateCartOk(type,cartJSON){
  //closeModal();
  notibarOrigin = "update";
  if(typeof cartJSON === "undefined"){
    //console.log("load cart.json 2 check");
    $.ajax({
      type:'GET',url:'/cart.json',dataType:'json',async:false,
      contentType: 'application/json',
      success:function(data){ cartJSON = data; },
      error:function(){failCart('update',type);}
    });
  }else{ cartJSON = JSON.parse(cartJSON); }
  //console.log("cartJSON",cartJSON);
  checkCart("update",type,JSON.stringify(cartJSON));
}

function img2cart(container,form_id){
  //console.log("img2cart",container);
  $("body").attr("data-cloned",0);
  if($("div[data-container='"+container+"']").length && !container.includes("modal")){
    var $img = $("div[data-container='"+container+"']").first().find("[data-type='product-image']").first();
    if($img.length){
      $('body').css('overflow', 'hidden');
      var bgcolor = "#fdfdfd";
      var background = $img.css("background");
      //var background = background.replace("rgba(0, 0, 0, 0)",bgcolor);
      //console.log("img2cart",background);
      var position = $img.offset();
      $("body").append('<div class="productImageClone"></div>');		
      var $imgClone = $('div.productImageClone');		
      $imgClone.css("background",background);
      $imgClone.css({'width' : $img.width() + 'px', "height" : $img.height() + 'px'});
      $imgClone.css({'top' : position.top + 'px', "left" : position.left + 'px'});
      $imgClone.fadeIn("slow");
      var $cartButton = $("button.dgs-header-button[button='cart']");
      var cartButtonPosition = $cartButton.offset();
      $imgClone.animate({
        top: cartButtonPosition.top + 'px',
        left: cartButtonPosition.left + 'px',
        width: $cartButton.width() + 'px',
        height:$cartButton.height() + 'px'
      }, 1000, "swing", function() {
        $(this).css("transition","0.75s");
        $(this).addClass("productImageOut");
        setTimeout(function(){
          //closeModal();
          $(this).remove();
          $('body').css('overflow', 'auto').attr("data-cloned",1);
          openCartToast();
        }, 750);
      });
    }else{ $("body").attr("data-cloned",1);openCartToast(); }
  }else{ $("body").attr("data-cloned",1);openCartToast(); }
}
function addSplitted(form_id, dataContainer){
  var $container 		= $("div[data-container='"+dataContainer+"']")
  var splitted			= [];
  var variantId 		= parseInt($container.find(".dgs-product-variants option:selected").val());
  var amount 			= parseInt($container.find("#quantity_dgs-product-details").val());    
  for(var i = 0; i < amount; i++){
    var uniqueID		= md5(variantId +" / "+ i +" / "+ Date.now());
    var variantItem 	= {
      'id': variantId,
      'quantity': 1,
      'properties': {'__unique':uniqueID}
    };
    splitted.push(variantItem);
  }
  addItems2Cart(splitted,"splitted");
}
function addItems2Cart(items,method,button = ""){
  var addcartAction 	= "button";
  closeCartToast();
  var toastArr		= [];
  var amount 		= items.length;
  let itemData 		= {'items': items};
  //console.log("addItems2Cart",method,addcartAction,button);
  var jsonData		= JSON.stringify(itemData);
  if(method == "boxbundle"){
    var amount 		= itemData.items[1].quantity;
  }else if(addcartAction == "button"){
    if($(".dgs-header-amount").length){ $(".dgs-header-amount").find("em").attr("update",""); }
    if(button != ""){ $("[button='"+button+"']").attr('status','pending'); }
  }
  setTimeout(function(){ 
    $.ajax({
      url: '/cart/add.js',
      dataType: 'json', type: 'POST',
      contentType: 'application/json',
      data: jsonData,
      success:  function(data){   
        if(button == "reorder-checkout"){
          var listLink 	= rootURL+"/checkout?payment=free&step=review";
          window.parent.location.href = listLink;
        }else{
          if(addcartAction == "toast"){
            const items = data.items;
            const lastItem = items[items.length - 1];
            //console.log(lastItem);
            toastArr.push(lastItem.product_title);
            toastArr.push(lastItem.image);
            var preload = (lastItem.image).replace(".1.", ".1_120x.");
            $('<img/>').attr('src',preload).on('load', function() { $(this).remove(); });
            toastArr.push(parseInt(amount));
            toastArr.push(lastItem.final_price);
            $("body").attr("data-cloned",1);
          }else if(addcartAction == "button"){
            toastArr.push(method);
            toastArr.push(amount);
            toastArr.push(button);
          }
          addToCartOk(toastArr);
        }
      },error: function(data){failCart('add',addcartAction);}
    });
  }, 50);
}
function addBoxbundle(form_id, dataContainer){
  var addcartAction = "button";
  var $container 		= $("div[data-container='"+dataContainer+"']")  
  var $selected 		= $container.find(".dgs-product-variants option:selected");
  var variantId 		= parseInt($selected.val());
  var uniqueBundleID	= md5(variantId +" / "+ i +" / "+ Date.now());
  var amount 			= parseInt($container.find("input[name='quantity']").val());
  var boxbundleVariant 	= $selected.attr("boxbundle-variant");
  var boxbundleQuantity	= parseInt($selected.attr("boxbundle-quantity"));
  var boxbundleAmount	= amount * boxbundleQuantity;
  var $bundleboxItem 	= $container.find(".dgs-product-variants option[value='"+boxbundleVariant+"']");
  var boxbundleSKU 		= $bundleboxItem.attr("data-sku");
  if(boxbundleVariant == 0 || typeof boxbundleVariant === "undefined" || boxbundleQuantity == 0 || typeof boxbundleQuantity === "undefined"){
    addToCart(form_id);
  }else{
    if(typeof boxbundleSKU === "undefined"){
      setTimeout(function(){
        failCart("add",addcartAction,"Zugewiesene Produkte konnten nicht gefunden werden!");
      }, 1500);
    }else{
      var boxbundleName 	= $bundleboxItem.text();
      var productTitle 		= $container.find(".dgs-product-variants").attr("data-productname");
      var boxbundleTitle 	= (boxbundleName).replace(/\s+/g, ' ').trim();
      var boxbundleContent 	= (boxbundleQuantity + " x " + boxbundleName).replace(/\s+/g, ' ').trim();
      if(boxbundleVariant > 0 && boxbundleQuantity > 0){
        //console.log("addBoxbundle",variantId,amount,boxbundleVariant,boxbundleQuantity,boxbundleAmount,boxbundleName);
        var variantsArr			= {};
        var bundleChilds 		= [];
        var selectedVariants	= [];
        var bundleChild			= {'title':boxbundleTitle,'sku':boxbundleSKU.toString(),'quantity':boxbundleQuantity};
        bundleChilds.push(bundleChild);    
        variantsArr['_items'] 	= bundleChilds;
        variantsArr['_master'] 	= uniqueBundleID;
        variantsArr['_type'] 	= "boxbundle";
        variantsArr['CONTENT'] 	= boxbundleContent;
        var bundleItem 		= {'id': parseInt(variantId), 'quantity': amount, 'properties': variantsArr};    
        var variantItem 	= {'id': parseInt(boxbundleVariant), 'quantity': boxbundleAmount, 'properties': {'_bundle': uniqueBundleID}};
        selectedVariants.push(variantItem);
        selectedVariants.push(bundleItem);
        //console.log("selectedVariants",selectedVariants);
        addItems2Cart(selectedVariants,"boxbundle");
      }else{      
        setTimeout(function(){
          failCart("add",addcartAction,"Der Artikel konnte nicht hinzugefügt werden!");
        }, 1500);
      }
    }
  }
}
function addItem(form_id, method = "form"){
  var addcartAction = "button";
  if(addcartAction == "toast"){
    closeCartToast();
  }
  var cartbarOpen = parseInt($("body").attr("data-cartbar"));
  if(pageType == "product" && cartbarOpen != 1){
    var dataContainer = form_id.replace("form-","block-");
  }else if(pageType == "index" && cartbarOpen != 1){
    var dataContainer = form_id.replace("form-","block-");
    var dataContainer = dataContainer+"-line";
  }else if(form_id.includes("add2cart-modal")){
    var dataContainer = form_id.replace("add2cart-modal-","block-");
    var dataContainer = dataContainer + "-modal";
  }else{   
    var dataContainer = form_id.replace("add2cart-","");      
  }
  //console.log("dataContainer",form_id,dataContainer,addcartAction);
  if(addcartAction == "button"){
    if($(".dgs-header-amount").length){ $(".dgs-header-amount").find("em").attr("update",""); }
    $("div[data-container='"+dataContainer+"']").find(".dgs-product-buttons").attr('status','pending');
  }else{
    $("div[data-container='"+dataContainer+"']").find(".dgs-product-buttons").attr('loadercover','');
  }
  //$(".dgs-header-button[button='cart']").attr('loadercover','');
  //img2cart(dataContainer,form_id);
  if(method == "splitted"){ addSplitted(form_id, dataContainer); }
  else if(method == "boxbundle"){ addBoxbundle(form_id, dataContainer); }
  else{ addToCart(form_id, dataContainer); }
}
function addToCart(form_id, dataContainer){
  var toastArr	= [];
  var form_str 	= $('#'+form_id).serialize();
  var form_arr 	= form_str.split("quantity=");
  var form_arr1	= form_arr[1];
  var form_arr2 = form_arr1.split("&");
  var form_quantity = parseInt(form_arr2[0]);
  var addcartAction = "button";
  $.ajax({
    type: 'POST', 
    url: '/cart/add.js', dataType: 'json',
    data: $('#'+form_id).serialize(),
    beforeSend: function(){ /*closeModal();*/ },
    success: function(data){
      //console.log("addJSON",data);
      if(typeof ttq !== "undefined"){
        ttq.track('AddToCart',{ 
          content:data.product_title,
          content_id:data.id,quantity:form_quantity,currency:'EUR',
          price:parseFloat(data.discounted_price / 100),
          value:parseFloat((data.discounted_price * form_quantity) / 100)
        });
      }
      if(addcartAction == "toast"){
        toastArr.push(data.product_title);
        toastArr.push(data.image);
        var preload = (data.image).replace(".1.", ".1_120x.");
        $('<img/>').attr('src',preload).on('load', function() { $(this).remove(); });
        toastArr.push(form_quantity);
        toastArr.push(data.final_price);
      }else if(addcartAction == "button"){
        toastArr.push(form_id);
        toastArr.push(dataContainer);
      }
      addToCartOk(toastArr);
    },error:function(){failCart('add',addcartAction);}
  });
}
function addToCartOk(toastArr){
  notibarOrigin = "add";
  var addcartAction = "button";
  $.ajax({
    type:'GET',url:'/cart.json',dataType:'json',async:false,
    contentType: 'application/json',
    success:function(data){
      //closeModal();
      //console.log("cartJSON",data);
      checkCart("add",addcartAction,JSON.stringify(data),toastArr);
    },error:function(){failCart('add',addcartAction);}
  });
}
function addCartContent(addcartAction,toastArr){
  if(addcartAction == "page"){
    window.location = "/cart";
  }else if(addcartAction == "sidebar"){
    loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar');
  }else if(addcartAction == "toast"){
    var toastContent = renderToast(toastArr);
    $(".dgs-carttoast-item").html(toastContent);
    loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar',1,0);
  }else if(addcartAction == "button"){
    if(toastArr[0] == "bulkvariants"){
      closeModal();
      loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar',1,0);
    }else if(toastArr[0] == "reorder" || toastArr[0] == "fast2cart"){
      if(toastArr[2] != ""){
        $("[button='"+toastArr[2]+"'][status]").attr('status','success');
        $("[button='"+toastArr[2]+"'][status]").closest(".dgs-table-row").attr('incart','1');
        setTimeout(function(){
          $("[button='"+toastArr[2]+"'][status]").removeAttr('status');
        }, 2500);
      }
      loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar',1,0);
    }else{
      $("div[data-container='"+toastArr[1]+"']").find("input[name='quantity']").val(1);
      $("div[data-container='"+toastArr[1]+"']").find(".dgs-product-buttons").attr('status','success');
      $("div[data-container='"+toastArr[1]+"']").find(".dgs-product-buttons").closest(".dgs-table-row").attr('incart','1');
      $("div[data-container='"+toastArr[1]+"']").find("span[incart]").removeAttr('dgs-hidden-important');
      loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar',1,0);
      setTimeout(function(){
        $("div[data-container='"+toastArr[1]+"']").find(".dgs-product-buttons").removeAttr('status');
      }, 2500);
    }
  }else{
    loadContent('dgs-cart-sidebar','shopify-section-dgs-cart-sidebar',1,0);
  }
}

function cartFail(obj, status){
  closeCartToast();
  closeModal();
  closeloader();
  closeloading();
}
function failCart(origin,type,text = ''){
  closeloader();
  closeCartToast();
  closeModal();
  closeloading();
  if(type == "sidebar"){}else{}
  if(origin == "add"){}else{}
  if(text != ""){ openInfoToast("error",text); }
}
function clearCart(type){
  if (confirm("Warenkorb wirklich leeren?") == true) {
    var addcartAction = "button";
    if(type == "page"){ loading(); }
    else if(type == "sidebar"){
      $(".dgs-cartbar-button").prop("disabled", true);
      $(".dgs-cartbar-item").find(".dgs-cartbar-item-response").attr("data-response","delete").fadeIn();
    }
    if(addcartAction == "button"){
      if($(".dgs-header-amount").length){ $(".dgs-header-amount").find("em").attr("update",""); }
    }
    $.ajax({
      url: '/cart/clear.js',
      dataType: 'json',
      async: false,
      type: 'POST',
      contentType: 'application/json',
      success: function(response){
        //console.log("response",response);
        updateCartContent(type);
      },error:function(){failCart('add',addcartAction);}
    });
  }
}
function openQuantitySlider(offerID){
  var $offerbox = $("div[offerbox='"+offerID+"']").first();
  $offerbox.attr("qty-slider",1);
}
function closeQuantitySlider(offerID){
  var $offerbox = $("div[offerbox='"+offerID+"']").first();
  $offerbox.attr("qty-slider",0);
}